import React from 'react';
import './blog6HighRiskPregnancy.css';

const HighRiskPregnancyBlog = () => {
  return (
    <div className="highrisk-blog-container">
      <h1>High-Risk Pregnancy: Understanding the Invisible Warnings and Ensuring Safe Motherhood</h1>
      <p className="high-risk-subheading">A comprehensive guide from Sukam Speciality Clinic & Fertility Centre</p>

      <section>
        <h2>🌸 Introduction: The Bulge That Speaks Volumes — But Are You Listening?</h2>
        <p>
          While most pregnancies progress naturally and joyfully, some journeys demand more than routine care. High-risk pregnancies require heightened awareness and clinical precision. At Sukam Speciality Clinic, we believe high-risk does not mean hopeless — it means we pay closer attention, act faster, and care deeper.
        </p>
      </section>

      <section>
        <h2>⚠️ When Pregnancy Demands Extra Attention</h2>
        <p>
          A pregnancy is labeled “high-risk” when there’s an increased chance of complications for the mother, baby, or both. This risk may exist from the start (due to diabetes, thyroid issues, or IVF conception) or develop mid-way (e.g., gestational diabetes or preeclampsia). Often, symptoms are subtle — and timely recognition can save lives.
        </p>
      </section>

      <section>
        <h2>👩‍⚕️ Who Needs Closer Monitoring?</h2>
        <ul>
          <li>Women with chronic illnesses: diabetes, hypertension, thyroid disorders</li>
          <li>Age &gt;35 years or &lt;18 years</li>
          <li>Previous cesarean or miscarriage history</li>
          <li>Multiple pregnancies (twins/triplets)</li>
          <li>Placental abnormalities (previa, abruption)</li>
          <li>Growth-restricted babies (IUGR)</li>
          <li>Low or high amniotic fluid</li>
        </ul>
      </section>

      <section>
        <h2>🧠 Silent Symptoms That Shouldn’t Be Ignored</h2>
        <ul>
          <li><strong>Persistent headaches:</strong> Can signal rising blood pressure or early preeclampsia</li>
          <li><strong>Visual changes/dizziness:</strong> May indicate vascular brain involvement</li>
          <li><strong>Sudden swelling of hands/face:</strong> Red flag for fluid retention or kidney compromise</li>
          <li><strong>Bleeding anytime during pregnancy:</strong> May suggest miscarriage or placental issues</li>
          <li><strong>Reduced baby movements:</strong> Possible fetal distress — never ignore</li>
          <li><strong>Abdominal tightening or leaking:</strong> Could mean preterm labor or membrane rupture</li>
        </ul>
      </section>

      <section>
        <h2>🧪 How Sukam Detects Risk Early</h2>
        <ul>
          <li>Doppler ultrasound for placental blood flow</li>
          <li>Growth scans for IUGR detection</li>
          <li>Blood pressure + proteinuria for preeclampsia screening</li>
          <li>GDM testing by 24–28 weeks</li>
          <li>Amniotic fluid index & biophysical profile</li>
          <li>CTG/NST for fetal heart monitoring</li>
        </ul>
      </section>

      <section>
        <h2>🩺 What Happens When Pregnancy is Declared High-Risk?</h2>
        <p>Our customized plans include:</p>
        <ul>
          <li>Weekly or biweekly monitoring</li>
          <li>Glucose tracking & insulin (for GDM)</li>
          <li>Low-dose aspirin (for preeclampsia prevention)</li>
          <li>Steroids for fetal lung maturity (if early delivery likely)</li>
          <li>NICU preparation in advance</li>
          <li>Planned induction or cesarean to avoid emergencies</li>
        </ul>
      </section>

      <section>
        <h2>🧑‍🍼 A Real Case from Our Clinic</h2>
        <p>
          <strong>Mrs. Lakshmi, 34:</strong> IVF pregnancy, presented with headaches and swelling at 31 weeks. BP was 150/100, and tests confirmed preeclampsia. With rapid intervention and steroids, she delivered a healthy baby at 34 weeks via cesarean. Both mother and baby are thriving today — a testament to vigilance and timely care.
        </p>
      </section>

      <section>
        <h2>💛 Our Philosophy</h2>
        <p>
          At Sukam, we don’t let high-risk define the experience. We empower women to feel in control, cared for, and fully supported. From screening to delivery — we walk beside you, ensuring every heartbeat is protected.
        </p>
      </section>

      <section>
        <h2>📌 Final Words: Trust, Track, and Talk</h2>
        <p>Ask yourself:</p>
        <ul>
          <li>Am I aware of my risk factors?</li>
          <li>Am I tracking fetal movement daily?</li>
          <li>Do I follow my instincts when something feels wrong?</li>
          <li>Am I keeping every antenatal appointment?</li>
        </ul>
        <div className="cta-box">
          💡 If there's even a flicker of doubt — don't delay. Talk to us. At Sukam, we listen before symptoms scream.
        </div>
      </section>
    </div>
  );
};

export default HighRiskPregnancyBlog;
